<template>
    <v-flex xs12 class="businesses-left">
        <AboutTile
            :canViewAbout="true"
            :canViewChair= "false"
            :canViewSponsors="false"></AboutTile>
    </v-flex>
</template>

<script>
    import { businessesConstants } from './businesses.constants';
    import { assetSummaryConstants } from '../MemberProfile/memberProfile.constants';
    import AboutTile from '../ChapterPage/AboutTile/AboutTile';

    export default {
        name: "BusinessesLeftSidebar",
        data() {
            return {
                businessesConstants,
                assetSummaryConstants,
            };
        },
        components: {
            AboutTile,
        },
    };
</script>

<style lang="scss">
    @import "../../common/styles/_colors.scss";
    @import "../../common/styles/_commonClasses.scss";

    .businesses-left {
        .establishment {
            .v-label {
                color: $ypo-gray-text !important;
                font-size: 14px;
                letter-spacing: 0.09px;
                line-height: 22px;
                padding: 0 0 0 0;
                font-weight: 500;
            }

            .v-input__slot {
                margin-bottom: 3px;
            }
        }
    }
</style>
